/* import __COLOCATED_TEMPLATE__ from './saved-messages-empty-state.hbs'; */
import Component from '@ember/component';

/**
 * Component displayed when the user does not have any existing saved messages
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: '',

  /**
   * @param {function}
   */
  onModalClose: undefined,

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * action called when the user clicks the close button
     */
    close() {
      this.onModalClose();
    },
  },
});
